import { Injectable } from '@angular/core';
//import { ICotizacion } from './../models/icotizacion';
import { IGuiaRecepcion } from './../models/iGuiaRecepcion.model';
import { ROUTE_LAVANDERIA } from './../constants/constant.model';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GuiarecepcionService {

  constructor(
    private apiService: ApiService,
    private httpClient: HttpClient
  ) { }

  insertarGuiaRecepcion(data: IGuiaRecepcion): Observable<any> {
    this.apiService.setUrlPathApi(ROUTE_LAVANDERIA.crudGuiaRecepcion);
    return this.apiService.executePostJson(data).pipe();
  }

  actualizarGuiaRecepcion(data: IGuiaRecepcion): Observable<any> {
    this.apiService.setUrlPathApi(ROUTE_LAVANDERIA.crudGuiaRecepcion);
    return this.apiService.executePutJson(data).pipe();
  }

  obtenerGuiaRecepcion(numint: number): Observable<any> {
    this.apiService.setUrlPathApi(ROUTE_LAVANDERIA.crudGuiaRecepcion);
    return this.apiService.execGetQueryJson(`/${numint}`).pipe();
  }

  buscarGuiaRecepcion(query: any, fdesde: string, fhasta: string, situac: string, lugemi: number, limit: number, offset: number): Observable<any> {
    this.apiService.setUrlPathApi(ROUTE_LAVANDERIA.crudGuiaRecepcion + 'buscar?');
    return this.apiService.execGetQueryJson(`fdesde=${fdesde}&fhasta=${fhasta}&codcli=${encodeURIComponent(query.codcli)}&situac=${situac}&lugemi=${lugemi}&limit=${limit}&offset=${offset}`).pipe();
  }

  calcularGuiaRecepcion(data: IGuiaRecepcion): Observable<any> {
    this.apiService.setUrlPathApi(ROUTE_LAVANDERIA.calcularGuiaRecepcion);
    return this.apiService.executePutJson(data).pipe();
  }


  descargarPDF(numint: number): Observable<any> {
    this.apiService.setUrlPathApiReport(ROUTE_LAVANDERIA.crudGuiaRecepcion);
    return this.apiService.execGetQueryJsonPDF(`${numint}/report/format-1.pdf`).pipe();
  }

  // eliminarGuiaRecepcion()
}
